import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  transform(
    items: any[],
    searchText: string = undefined,
    fieldName: string = undefined,
    innerFieldName: string = undefined
  ): any[] {
    if (!items || (items && !items.length)) {
      return [];
    }
    if (!searchText || (searchText && searchText.trim() === '')) {
      return items;
    }
    searchText = searchText.toLowerCase();

    if (!!fieldName) {
      if (!!innerFieldName) {
        return items.filter(item => {
          if (item && item[fieldName] && item[fieldName][innerFieldName]) {
            return item[fieldName][innerFieldName].toLowerCase().includes(searchText);
          }
          return false;
        });
      } else {
        return items.filter(item => {
          if (item && item[fieldName]) {
            return item[fieldName].toLowerCase().includes(searchText);
          }
          return false;
        });
      }
    } else {
      return items.filter(item => {
        return item.toLowerCase().includes(searchText);
      });
    }
  }

  transformIndexes(
    items: any[],
    searchText: string = undefined,
    fieldName: string = undefined,
    innerFieldName: string = undefined
  ): any[] {
    if (!items || (items && !items.length)) {
      return;
    }
    if (!searchText || (searchText && searchText.trim() === '')) {
      return;
    }
    searchText = searchText.toLowerCase();

    const res = new Array<number>();
    if (!!fieldName) {
      let i = -1;
      if (!!innerFieldName) {
        for (const item of items) {
          i++;
          if (
            item &&
            item[fieldName] &&
            item[fieldName][innerFieldName] &&
            item[fieldName][innerFieldName].toLowerCase().includes(searchText)
          ) {
            res.push(i);
          }
        }
        return res;
        /*return items.filter(item => {
          if (item && item[fieldName] && item[fieldName][innerFieldName]) {
            return item[fieldName][innerFieldName].toLowerCase().includes(searchText);
          }
          return false;
        });*/
      } else {
        for (const item of items) {
          i++;
          if (item && item[fieldName] && item[fieldName].toLowerCase().includes(searchText)) {
            res.push(i);
          }
        }
        return res;

        /*return items.filter(item => {
          if (item && item[fieldName]) {
            return item[fieldName].toLowerCase().includes(searchText);
          }
          return false;
        });*/
      }
    } else {
      let i = -1;
      for (const item of items) {
        i++;
        if (item.toLowerCase().includes(searchText)) {
          res.push(i);
        }
      }
      return res;
      /*return items.filter(item => {
        return item.toLowerCase().includes(searchText);
      });*/
    }
  }
}
